export default __webpack_public_path__ + "static/media/mobile_ale.155a9972.png";